import TcButton from 'components/UI/button/TcButton';
import { FC, memo, ReactNode } from 'react';

interface ITcFormButtons {
  onCancel?: () => void;
  onSubmit?: () => void;
  onAdvanceClick?: () => void;
  isAdvanceOpen?: boolean;
  className?: string;
  advanceContent?: ReactNode;
  noCancel?: boolean;
  submitButtonText?: string;
  cancelButtonText?: string;
  notPrimarySubmitButton?: boolean;
  loading?: boolean;
}

const TcFormButtons: FC<ITcFormButtons> = ({
  advanceContent,
  onCancel,
  onSubmit,
  onAdvanceClick,
  isAdvanceOpen,
  className,
  noCancel,
  submitButtonText,
  cancelButtonText,
  notPrimarySubmitButton,
  loading,
}) => {
  return (
    <>
      <div
        className={`transition-all duration-700 ease-in-out  col-span-full ${
          isAdvanceOpen ? 'max-h-[1000px] md:max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden -m-4 mt-2'
        }`}>
        {advanceContent}
      </div>
      <div className={`flex flex-col justify-between gap-4 mt-6 sm:items-center sm:flex-row col-span-full ${className}`}>
        <div>
          {onAdvanceClick && (
            <p className='relative z-50 m-0 cursor-pointer text-t-primary-color hover:underline' onClick={onAdvanceClick}>
              {isAdvanceOpen ? 'بستن' : 'جستجو پیشرفته'}
            </p>
          )}
        </div>
        <div className='flex flex-col sm:flex-row gap-x-4 gap-y-2'>
          {!noCancel && (
            <TcButton onClick={onCancel} loading={loading}>
              {cancelButtonText ? cancelButtonText : 'حذف فیلترها'}
            </TcButton>
          )}
          <TcButton type={!notPrimarySubmitButton ? 'primary' : 'default'} htmlType='submit' onClick={onSubmit} loading={loading}>
            {submitButtonText ? submitButtonText : 'جستجو'}
          </TcButton>
        </div>
      </div>
    </>
  );
};

export default memo(TcFormButtons);
